exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".burger__menu[data-v-7dd766a8]{width:28px;height:20px;display:flex;flex-direction:column;justify-content:space-between;cursor:pointer}.burger__row[data-v-7dd766a8]{height:2px;background:#0d3857;flex-shrink:0}", ""]);

